import React, { useEffect, useState, useRef } from "react";

const STORAGE_KEY = "infinite-world-locations";
const PANEL_STYLE = {
  background: "rgba(255,255,255,0.92)",
  border: "1px solid #c7c7c7",
  borderRadius: 6,
  padding: 8,
  boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
  fontFamily: '"MS Sans Serif", Tahoma, Arial, sans-serif',
};

export default function Notes({
  width = 280,
  height = 160,
  placeholder = "Type locations...",
}) {
  const [text, setText] = useState("");
  const timerRef = useRef(null);
  const DEFAULT_LOCATIONS = `# example locations (x, y)\n# tap 'goto' and enter a pair\n\n# center\n0, 0\n\n# bio\n0, 25000\n\n# playlist\n-25000, 0\n\n# photos\n25000, 0\n\n# contact\n0, -25000\n\n# locations panel\n-5000, -5000\n`;

  const loadDefaults = () => {
    setText(DEFAULT_LOCATIONS);
    try {
      localStorage.setItem(STORAGE_KEY, DEFAULT_LOCATIONS);
    } catch (e) {
      // ignore
    }
  };

  // load from localStorage on mount
  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const hasExisting = raw && raw.trim().length > 0;
      setText(hasExisting ? raw : DEFAULT_LOCATIONS);
    } catch (e) {
      // ignore (e.g., SSR or private mode)
      setText(DEFAULT_LOCATIONS);
    }
  }, []);

  // save with a short debounce
  useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      try {
        localStorage.setItem(STORAGE_KEY, text);
      } catch (e) {
        // ignore
      }
      timerRef.current = null;
    }, 450);
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [text]);

  return (
    <div
      style={{
        width,
        ...PANEL_STYLE,
      }}
    >
      <div
        style={{
          fontSize: 12,
          fontWeight: "normal",
          marginBottom: 8,
          color: "#111",
        }}
      >
        x,y coordinates
        <button
          type="button"
          onClick={loadDefaults}
          style={{
            marginLeft: 8,
            padding: "2px 6px",
            fontSize: 11,
            border: "1px solid #c7c7c7",
            borderRadius: 4,
            background: "rgba(255,255,255,0.92)",
            cursor: "pointer",
          }}
          title="Load default coordinates"
          aria-label="Load default coordinates"
        >
          default
        </button>
      </div>
      <textarea
        aria-label="locations"
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder={placeholder}
        style={{
          width: "100%",
          height,
          margin: "0 auto",
          resize: "vertical",
          padding: "8px",
          fontSize: 12,
          lineHeight: 1.3,
          borderRadius: 6,
          border: "1px solid rgba(0,0,0,0.06)",
          outline: "none",
          background: "transparent",
          fontFamily: '"MS Sans Serif", Tahoma, Arial, sans-serif',
          fontWeight: "normal",
          boxSizing: "border-box",
        }}
      />
      <div style={{ marginTop: 8, fontSize: 11, color: "#666" }}>
        Saved locally
      </div>
    </div>
  );
}
